import { render, staticRenderFns } from "./extended.vue?vue&type=template&id=2a908a64&scoped=true"
import script from "./extended.vue?vue&type=script&lang=js"
export * from "./extended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a908a64",
  null
  
)

export default component.exports